import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src229751525/src/app/components/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src229751525/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src229751525/src/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src229751525/src/app/globals.css");
